// src/hooks/useOrgChartData.js
import { useMemo } from "react";
import { stringToColor, customDepartmentSort } from "../utils/helpers";

export const useOrgChartData = (rawLeadershipData, rawHierarchyData) => {
  const { leadershipData, categorizedHierarchyData, categorizedLeadershipData } = useMemo(() => {
    // No need to clone here if we fix the mutations below.
    
    const supportDeptNames = ["HR", "Human Resources", "Admin", "IT", "Others"];

    // Leadership processing
    const cleanedLeadership = (rawLeadershipData || []).filter(p => p.department && !p.department.startsWith("<think>") && p.department.length < 30);
    const groupedLeadership = cleanedLeadership.reduce((acc, p) => {
      let deptName = p.department;
      const lowerDept = deptName.toLowerCase();
      if (lowerDept.includes("c-suite") || lowerDept.includes("c suite") || lowerDept.includes("leadership") || lowerDept.includes("cxo")) {
        deptName = "Leadership / CXO";
      }
      if (!acc[deptName]) acc[deptName] = [];
      acc[deptName].push(p);
      return acc;
    }, {});

    const finalLeadershipData = {
      departments: Object.keys(groupedLeadership).sort(customDepartmentSort).map(name => ({
        name,
        // --- FIX #1: AVOID IN-PLACE MUTATION ---
        // Use the spread operator `[...]` to create a new, sorted copy of the array.
        leaders: [...groupedLeadership[name]].sort((a, b) => a.score - b.score),
      })),
    };

    const leadershipDeptsForSidebar = finalLeadershipData.departments.map(d => ({ name: d.name, color: stringToColor(d.name) }));
    const leadershipLeadershipDept = leadershipDeptsForSidebar.filter(d => d.name.toLowerCase().includes("leadership / cxo"));
    const leadershipSupportDepts = leadershipDeptsForSidebar.filter(d => supportDeptNames.includes(d.name)).sort(customDepartmentSort);
    const leadershipCoreDepts = leadershipDeptsForSidebar.filter(d => !d.name.toLowerCase().includes("leadership / cxo") && !supportDeptNames.includes(d.name)).sort(customDepartmentSort);
    const finalCategorizedLeadershipData = { leadership: leadershipLeadershipDept, core: leadershipCoreDepts, support: leadershipSupportDepts };

    // Hierarchy processing
    const hierarchyDepts = (rawHierarchyData?.children || []).map(d => ({ ...d, color: stringToColor(d.name) }));
    const leadershipDept = hierarchyDepts.find(d => d.name.toLowerCase().includes("c-suite") || d.name.toLowerCase().includes("c suite"));
    const hierarchySupportDepts = hierarchyDepts.filter(d => supportDeptNames.includes(d.name)).sort(customDepartmentSort);
    const hierarchyCoreDepts = hierarchyDepts.filter(d => !d.name.toLowerCase().includes("c-suite") && !d.name.toLowerCase().includes("c suite") && !supportDeptNames.includes(d.name)).sort(customDepartmentSort);
    const finalCategorizedHierarchyData = {
      leadership: leadershipDept ? [{ ...leadershipDept, name: "Leadership / CXO" }] : [],
      core: hierarchyCoreDepts,
      support: hierarchySupportDepts,
    };

    // --- FIX #2: CORRECT THE RETURNED OBJECT ---
    // Ensure the correct variables are assigned to the correct keys.
    return { 
      leadershipData: finalLeadershipData, 
      categorizedHierarchyData: finalCategorizedHierarchyData, // Was returning the wrong variable here
      categorizedLeadershipData: finalCategorizedLeadershipData 
    };
  }, [rawLeadershipData, rawHierarchyData]);

  return { leadershipData, categorizedHierarchyData, categorizedLeadershipData };
};